import React from 'react'
import Form from '../form.js'
import '../styles/contact.css'
import contactImage from '../assets/refactored/oliviaContactPage.png'

function contact() {
  return (
      <div className='contact-content-container'>
        <div className='contact-text'>
          <span><h1>Contact Me</h1></span>
          <Form />
          <p>For all booking and teaching inquiries, please use the above form to contact Olivia
          directly.</p>
        </div>
        <div className='contact-image'>
          <img src={contactImage} alt="Olivia Helman" className="contact-img" loading="eager" />
        </div>

    </div>
  )
}

export default contact
